import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import history from '../../../routes/history';
import { BotsCreators } from '../../../store/actions/bots';

import style from './style.module.scss';

import newBotImg from './icone_newbot.svg';

import Menu from '../Menu';
import ModalCloneVoicebot from './ModalCloneVoicebot';

class Box extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      deleting: false,
      modalIsOpened: false,
    };
  }

  onCardClick = () => {
    const { id, type, creatorBotRequest } = this.props;

    if (type === 'voice') {
      history.push(`/bots/${id}/criador`);
      return;
    }

    creatorBotRequest(id);
  };

  handleRemoveBot = (id) => {
    const { removeBotRequest, removeVoiceBotRequest, type } = this.props;

    const isVoiceBot = type === 'voice';
    if (isVoiceBot) {
      removeVoiceBotRequest(id);
    } else {
      removeBotRequest(id);
    }

    this.closeDeletePrompt();
  };

  handleCloneVoiceBot = ({ title }) => {
    const { cloneVoiceBotRequest, id } = this.props;

    cloneVoiceBotRequest({ botId: id, title }, () =>
      this.setState({ modalIsOpened: false })
    );
  };

  openMenu = () => {
    this.setState({ showMenu: true });
  };

  closeMenu = () => {
    this.setState({ showMenu: false });
  };

  openDeletePrompt = () => {
    this.setState({ deleting: true });
    this.closeMenu();
  };

  closeDeletePrompt = () => {
    this.setState({ deleting: false });
  };

  render() {
    const { title, description, type, id, img } = this.props;
    const { deleting, showMenu, modalIsOpened } = this.state;
    const { push } = history;

    return (
      <div
        className={`box-iniciar ${style.box}`}
        style={{ position: 'relative', paddingTop: '40px' }}
      >
        <span
          className={classnames('box-iniciar__tag', {
            'box-iniciar__tag--orange': type === 'chat',
            'box-iniciar__tag--blue': type === 'voice',
          })}
        >
          {type === 'voice' ? 'Voicebot' : 'Chatbot'}
        </span>

        {deleting && (
          <div className={style.deletePrompt}>
            <img alt="" src={require('./icon_delete.svg')} />
            <span>
              Deseja realmente apagar o bot<strong> {title}</strong>?
            </span>
            <button type="button" onClick={this.closeDeletePrompt}>
              não
            </button>
            <button type="button" onClick={() => this.handleRemoveBot(id)}>
              sim
            </button>
          </div>
        )}

        {showMenu && (
          <Menu
            defaultAction={this.closeMenu}
            criador={() => push(`/bots/${id}/criador`)}
            configurar={() => push(`/bots/${id}/configuracoes`)}
            publicar={() => push(`/bots/${id}/canais`)}
            clonar={() => this.setState({ modalIsOpened: true })}
            excluir={id !== 'sandbox' ? this.openDeletePrompt : null}
            botType={type}
          />
        )}

        {modalIsOpened && (
          <ModalCloneVoicebot
            isActive={modalIsOpened}
            onClose={() => this.setState({ modalIsOpened: false })}
            onSubmit={this.handleCloneVoiceBot}
            initialTitle={title}
          />
        )}

        <div className="post-action">
          <div onClick={this.openMenu} className={style.buttonMore}>
            &bull;&bull;&bull;
          </div>
        </div>
        <div
          style={{ cursor: 'pointer', height: '100%' }}
          onClick={this.onCardClick}
        >
          <div className="box-iniciar-avatar">
            <div className="box-iniciar-avatar-imagem pointer">
              <img
                style={{
                  objectFit: 'contain',
                  padding: img ? '0' : '10px',
                  paddingTop: '5px',
                }}
                alt=""
                src={img || newBotImg}
              />
            </div>
          </div>
          <div className="box-iniciar-titulo">
            <p>{title}</p>
          </div>
          <div className="box-iniciar-subtitulo">
            <p>{description}</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bots: state.bots,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(BotsCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Box);
